import React, {useEffect} from 'react';
import {ThemedButton} from "../../../app";
import {CssVariant, FsVarVariant} from "../../fusion-ui/config/FusionConfig";
import {addSize, checkNullStr} from "../../fusion-ui/utils/ReactUtils";

/**
 * Create a theme based icon-button component.
 *
 * @example
 *     <ThemedIconButton
 *            className={''}
 *            tooltip={'Heart Button'}
 *            icon={'fa fa-heart'}
 *            size={'30px'}
 *            iconSize={'6px'}
 *            asLoading={false}
 *            loadingVariant={'light'}
 *            disabled={false}
 *            circular={true}
 *            iconAsImage={false}
 *            style={{}}
 *            onClick={handleClick}
 *            {...rest}
 *     />
 *
 *  //Implementation-2 - tagged
 *  const theme = useTheme();
 *      <ThemedIconButton
 *             className={''}
 *             mx={2}
 *             ml={3}
 *             variant={theme.primaryAlt}
 *             bgColor={'transparent'}
 *             hoverBgColor={'transparent'}
 *             hoverColor={theme.primaryAltDark}
 *             color={theme.primaryAlt}
 *             iconSize={'28px'}
 *             tooltip={'Message Notifications'}
 *             tag={'15'}
 *             icon={'bi bi-heart'}
 *        />
 *
 *  //Short implementation - outlined
 *
 * For more implementation information, see {@link ThemedButton}
 */
const ThemedIconButton = React.memo(({
                                         wrapperClassName = "",
                                         className = "",
                                         tagClassName = '',
                                         tooltip,
                                         icon,
                                         size = '30px',
                                         iconSize = '',
                                         asLoading,
                                         loadingVariant = CssVariant.light,
                                         disabled,
                                         circular = true,
                                         iconAsImage,
                                         style = {},
                                         tagStyle = {},
                                         onClick,
                                         tag,
                                         tagColor = 'white',
                                         tagBgColor = 'red',
                                         tagSize = FsVarVariant.SM,
                                         borderWidth = '1px',
                                         href,

                                         mx,
                                         ml,
                                         mr,
                                         my,
                                         mt,
                                         mb,

                                         bgColor,
                                         hoverBgColor,
                                         borderColor,
                                         hoverBorderColor,
                                         color,
                                         hoverColor,
                                         rippleColor,
                                         variant,
                                         variantLight,
                                         disableVariant = "sm",
                                         outlined = false,
                                         elastic = false,
                                         elasticActive = false,

                                         ...rest
                                     }) => {
    const TAG = "ThemedIconButton";

    useEffect(() => {

    }, []);

    return (
        checkNullStr(tag) ? createTagButton() : createButton()
    )

    function createTagButton() {
        return <span className={'position-relative'}>
            {/*tag*/}
            <span
                className={`position-absolute fw-semi-bold cursor-default select-none rounded-10 text-center d-flex jc-center al-center text-nowrap flex-nowrap ${tagClassName}`}
                style={{
                    padding: `0 .3rem`,
                    fontSize: tagSize,
                    backgroundColor: tagBgColor,
                    color: tagColor,
                    height: addSize(tagSize, 5),
                    top: '-.1rem',
                    right: '.1rem',
                    zIndex: 1,
                    ...tagStyle,
                }}>
                {tag}
            </span>

            {/*btn*/}
            {createButton()}
        </span>
    }

    function createButton() {
        return <ThemedButton
            wrapperClassName={wrapperClassName}
            className={`p-2 text-center ${className}`}
            style={{...style}}
            tooltip={tooltip}
            width={size}
            height={size}
            iconSize={iconSize}
            circular={circular}
            asLoading={asLoading}
            disabled={disabled}
            icon={icon}
            iconAsImage={iconAsImage}
            loadingWidth={size}
            loadingVariant={loadingVariant}
            textOnLoading={false}
            bgColor={bgColor}
            hoverBgColor={hoverBgColor}
            borderColor={borderColor}
            hoverBorderColor={hoverBorderColor}
            color={color}
            text={''}
            hoverColor={hoverColor}
            rippleColor={rippleColor}
            variant={variant}
            variantLight={variantLight}
            borderWidth={borderWidth}
            disableVariant={disableVariant}
            onClick={onClick}
            mx={mx}
            ml={ml}
            mr={mr}
            my={my}
            mt={mt}
            mb={mb}
            href={href}
            outlined={outlined}
            elastic={elastic}
            elasticActive={elasticActive}
            {...rest}
            sleek={false}
        />
    }
});
export default ThemedIconButton;
